import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import {
    defaultErrorSnackbarConfig,
    defaultInfoSnackbarConfig,
    defaultSuccessSnackbarConfig,
    defaultWarningSnackbarConfig,
    MatSnackBarContentInterface,
} from './mat-snackbar';

@Component({
    selector: 'app-mat-snackbar',
    templateUrl: './mat-snackbar.component.html',
})
export class MatSnackbarComponent {
    constructor(
        @Inject(MAT_SNACK_BAR_DATA) public data: MatSnackBarContentInterface,
        public snackbar: MatSnackBar
    ) {}

    public static getSuccessConfig(description: string, isButton: boolean, url: string, displaySeconds: number): MatSnackBarConfig {
        return {
            data: {
                description,
                ...defaultSuccessSnackbarConfig,
                ...(isButton && { isButton }),
                ...(isButton && url && { url }),
            },
            duration: displaySeconds,
        };
    }

    public static getErrorConfig(description: string, isButton: boolean, url: string, displaySeconds: number): MatSnackBarConfig {
        return {
            data: {
                description,
                ...defaultErrorSnackbarConfig,
                ...(isButton && { isButton }),
                ...(isButton && url && { url }),
            },
            duration: displaySeconds,
        };
    }

    public static getInfoConfig(description: string, isButton: boolean, url: string, displaySeconds: number): MatSnackBarConfig {
        return {
            data: {
                description,
                ...defaultInfoSnackbarConfig,
                ...(isButton && { isButton }),
                ...(isButton && url && { url }),
            },
            duration: displaySeconds,
        };
    }

    public static getWarningConfig(description: string, isButton: boolean, url: string, displaySeconds: number): MatSnackBarConfig {
        return {
            data: {
                description,
                ...defaultWarningSnackbarConfig,
                ...(isButton && { isButton }),
                ...(isButton && url && { url }),
            },
            duration: displaySeconds,
        };
    }
}
